export default {
  FORFAIT: {
    HEURES: 'Forfait Heures',
    JOURS: 'Forfait Jours',
  },
}
